import "./App.css";
import AppRoutes from "./router/AppRoutes";

function App() {
  return (
    <div className="App" style={{ fontFamily: "Nunito" }}>
      <AppRoutes />
    </div>
  );
}

export default App;
